// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Pino from "../../../bindings/Pino.bs.js";
import * as Js_dict from "@rescript/std/lib/es6/js_dict.js";
import * as Constants from "../../../common/Constants.bs.js";
import * as Js_promise from "@rescript/std/lib/es6/js_promise.js";
import * as Belt_Option from "@rescript/std/lib/es6/belt_Option.js";
import * as TermsHeader from "./TermsHeader.bs.js";
import ReactRenderHtml from "react-render-html";
import * as JsxRuntime from "react/jsx-runtime";
import * as PrezzeePublicClient from "../../../api/PrezzeePublicClient.bs.js";

function TermsPromotionsSingle(props) {
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                JsxRuntime.jsx(TermsHeader.make, {
                      title: props.promotionTermTitle
                    }),
                JsxRuntime.jsx("div", {
                      children: ReactRenderHtml(props.promotionTerm),
                      className: "prose-lg container mx-auto tracking-wider my-20 px-8"
                    })
              ]
            });
}

function getServerSideProps(param) {
  var query = param.query;
  if (Belt_Option.isNone(Js_dict.get(query, "preview"))) {
    param.res.setHeader("Cache-Control", Constants.ssr_page_cache);
  }
  var uid = Belt_Option.getWithDefault(Js_dict.get(query, "uid"), "");
  return Js_promise.$$catch((function (e) {
                Pino.logger.error({
                      err: e,
                      source: "Articles By Slug API"
                    }, "error: Could not retrieve Single Promotion Term");
                return Promise.resolve({
                            props: {
                              promotionTermTitle: "",
                              promotionTerm: ""
                            }
                          });
              }), Js_promise.then_((function (singleTerm) {
                    return Promise.resolve({
                                props: {
                                  promotionTermTitle: singleTerm.title,
                                  promotionTerm: singleTerm.content
                                }
                              });
                  }), PrezzeePublicClient.getPromotionTermsSingle(uid)));
}

var make = TermsPromotionsSingle;

export {
  make ,
  getServerSideProps ,
}
/* Pino Not a pure module */
